import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SHOW_CHAT_BOX = 'ChatBox.showChatBox';
var HIDE_CHAT_BOX = 'ChatBox.hideChatBox';
var initialState = {
  showChatBox: false
};
var showChatBox = function showChatBox() {
  return {
    type: SHOW_CHAT_BOX
  };
};
var hideChatBox = function hideChatBox() {
  return {
    type: HIDE_CHAT_BOX
  };
};
var chatBoxReducer = function chatBoxReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SHOW_CHAT_BOX:
      return _objectSpread(_objectSpread({}, state), {}, {
        showChatBox: true
      });
    case HIDE_CHAT_BOX:
      return initialState;
    default:
      return state;
  }
};
export { chatBoxReducer, showChatBox, hideChatBox };